export default __webpack_public_path__ + "aee65d663f8717f72395db04140b5bfa.svg";